import { Button, Chip, Stack } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { format } from 'date-fns';
import { compact, isEmpty, values } from 'lodash';
import { filterListOrdersForProductFulfillment } from 'store/thunks/workQueueThunks';
import FacilityFilterStatusChip from './FacilityFilterStatusChip';

const ProductFulfillmentStatusBar = () => {
  const dispatch = useDispatch();
  const filter = useSelector(({ workQueue }) => workQueue.productFulfillment?.filter);

  const removeFilter = (filterName) => () => {
    dispatch(
      filterListOrdersForProductFulfillment({
        filter: {
          ...filter,
          [filterName]: undefined,
        },
      })
    );
  };

  const removeAllFilter = () =>
    dispatch(
      filterListOrdersForProductFulfillment({
        filter: {},
      })
    );

  return (
    <Stack direction='row' spacing={1}>
      <FacilityFilterStatusChip
        removeFilter={removeFilter}
        selectedFacilities={filter?.fulfillingPharmacyIds || []}
      />

      {filter.patientName && (
        <Chip
          label={`Name = ${filter.patientName}`}
          variant='contained'
          onDelete={removeFilter('patientName')}
        />
      )}

      {filter.orderId && (
        <Chip
          label={`Order Id = ${filter.orderId}`}
          variant='contained'
          onDelete={removeFilter('orderId')}
        />
      )}

      {filter.partnerAccount && (
        <Chip
          label={`Partner Account = ${filter.partnerAccount}`}
          variant='contained'
          onDelete={removeFilter('partnerAccount')}
        />
      )}
      {filter.shipByDate && (
        <Chip
          label={`Ship By Date = ${format(new Date(filter.shipByDate), 'MM/dd/yyyy')}`}
          variant='contained'
          onDelete={removeFilter('shipByDate')}
        />
      )}

      {!isEmpty(compact(values(filter))) && <Button onClick={removeAllFilter}>Remove All</Button>}
    </Stack>
  );
};

export default ProductFulfillmentStatusBar;
